<template>
  <span id="receiving-detail-dialog">
    <span><a @click="handleOpenDialog" class="text-link">{{ $t('shipmentTracking.receiving') }}</a></span>
    <el-dialog
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="65%">
      <span slot="title">
        <el-row :gutter="20">
          <el-col :span="24">
            <span class="el-dialog__title">
              {{ $t('shipmentTracking.wholesalerBreakdown') }}
            </span>
            <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
              <el-button @click="handleSearch" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
            </el-tooltip>
            <span class="span-small-list">
              <span class="el-pagination__title">{{ $t('shipmentTracking.totalUnits') }}</span>
              {{ totalUnits }}
            </span>
            <span class="span-small-list">
              <span class="el-pagination__title">{{ $t('shipmentTracking.received') }}</span>
              {{ totalReceivedUnits }}
            </span>
          </el-col>
        </el-row>
      </span>
      <el-table
          :data="consigneeList"
          v-loading="loading"
          id="receiving-detail-data-list"
          size="mini"
          tooltip-effect="dark"
          width="80%"
          class="dark-blue-table"
          :empty-text="$t('common.noRecords')"
          @sort-change="handleSortChange"
          :default-sort="{prop: 'consigneeName', order: 'ascending'}"
          sortable
          stripe>
          <el-table-column
             prop="consigneeName"
            :label="$t('shipmentTracking.consigneeName')"
             align="left"
             header-align="center"
            :min-width="30"
            sortable="custom"/>
          <el-table-column
             prop="billed"
            :label="$t('shipmentTracking.billed')"
            align="center"
            :min-width="30"
            sortable="custom">
          </el-table-column>
          <el-table-column
             prop="received"
            :label="$t('shipmentTracking.received')"
            align="center"
            :min-width="30"
            sortable="custom">
          </el-table-column>
        </el-table>
      <div id="receiving-detail-dialog-footer" slot="footer" class="pagination-footer" v-show="totalConsignees > 0">
        <span class="el-pagination__total" slot>
          <span class="el-pagination__title" slot>{{ $t('shipmentTracking.totalConsignees') }}</span>
          {{ totalConsignees }}
        </span>
        <el-pagination
            :page-sizes="sizes"
            :page-size="searchParams.rows"
            :current-page.sync="searchParams.page"
            @size-change="handleSearchChangeLimit"
            @current-change="handleSearchChangePage"
            :total="totalConsignees"
            layout="sizes, prev, pager, next, jumper"
          >
      </el-pagination>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import constants from '@/utils/constants';

export default {
  name: 'ReceivingDetailDialog',
  props: {
    currentRow: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES,
      consigneeList: [],
      totalConsignees: 0,
      totalReceivedUnits: 0,
      totalUnits: 0,
      loading: false,
      searchParams: {
        origin: null,
        shipDate: null,
        rows: constants.TABLES.DEFAULT_LIMIT,
        page: constants.TABLES.DEFAULT_PAGE,
        pageResults: true,
        orderField: 'consigneeName',
        orderDirection: constants.TABLES.ORDER_DIRECTION.ascending
      }
    };
  },
  methods: {
    handleOpenDialog() {
      this.dialogVisible = true;
      this.searchParams.origin = this.currentRow.origin;
      this.searchParams.shipDate = this.currentRow.shipDate;
      this.handleSearch();
    },
    handleSearchChangeLimit(val) {
      this.searchParams.rows = val;
      this.searchParams.page = constants.TABLES.DEFAULT_PAGE;
      this.handleSearch();
    },
    handleSearchChangePage(val) {
      this.searchParams.page = val;
      this.handleSearch();
    },
    handleSortChange({ prop, order }) {
      this.searchParams.orderField = prop;
      this.searchParams.orderDirection = constants.TABLES.ORDER_DIRECTION[order];
      this.handleSearch();
    },
    handleSearch() {
      this.loading = true;
      this.$store.dispatch('loads/getWholesalerBreakdown', this.searchParams).then(
        (response) => {
          this.consigneeList = response.data;
          this.totalConsignees = response.totalRows;
          this.totalUnits = response.totalUnits;
          this.totalReceivedUnits = response.totalReceivedUnits;
        }
      ).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
  span#receiving-detail-dialog {
    .text-link {
      text-decoration: underline;
      color: #59AFE1;
      font-size: 10px;
      font-weight: 400;
    }

    .span-small-list {
      display: inline;
      margin-left: 1rem;
    }

    th {
      .cell {
        line-height: 32px;
        height: 32px;
      }
    }
  }

@media (max-width: 450px) {
    span#receiving-detail-dialog .span-small-list {
      display: block;
      margin-left: 0;
    }
}
</style>
